(function () {
  const Core = window.RB.Core;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Annie, Fiery": {
      bonusDamage: function (state, src, item, t) {
        return state.objs[src].controller === item.controller ? 1 : 0;
      },
    },

    "Tibbers": {
      play: [{ op: "deal", spec: { type: "unit", atBf: true }, n: 3 }],
    },

    "Firestorm": {
      targets: [{ bind: "b", spec: { zone: "battlefield" }, prompt: "Deal 3 to all enemy units at which battlefield?" }],
      play: [{ op: "deal", spec: { type: "unit", enemy: true }, at: "$b", n: 3 }],
    },

    "Dark Child - Starter": {
      triggers: [{
        on: "endOfTurn", you: true,
        label: "ready 2 runes",
        program: [{ op: "readyRunes", n: 2 }],
      }],
    },

    "Incinerate": {
      play: [{ op: "deal", to: "$t1", n: 2 }],
      targets: [
        { bind: "t1", spec: { type: "unit", atBf: true }, prompt: "Deal 2 to..." },
      ],
    },
  });
})();
